<template lang="pug">
  .edit-auto-delivery-change-color-modal(v-if="subInEdit && subInEdit.product_info")
    .missing-advisor.text-center(v-if="redirectToAdvisor")
      p.xs-f-small.lg-f-medium.max-at-tweak For best results please fill out the Color Advisor.
      p.xs-f-small.lg-f-medium.max-at-tweak Redirecting...

    .has-advisor(v-else)
      template(v-if="subInEdit && subInEdit.product_info.product_type == 'color_kit'")
        try-it-on(:compare-product-id="subInEdit.product_info.id" :view-on-model="true" @select="changeColor" @cancel="cancel" data-mr-ass="change-color-modal")

      template(v-else)
        .title-wrap.xs-12.text-center
          SectionTitle(text="Change Shade")

        .products-wrap.xs-12
          .choose-wrap.xs-12
            p.xs-f-small.max-at-tweak Choose another shade:
          products.xs-12(:product-type="subInEdit.product_info.product_type" v-slot="{ products }")
            template(v-for="product in products")
              .product-wrap.xs-6.text-center(v-if="productShouldShow(product)" :class="{selected: (!selectedProduct && product.id == subInEdit.product_id) || (selectedProduct && product.id == selectedProduct.id)}" data-mr-ass="product-wrap")
                button.product-button(type="button" @click="selectProduct(product)")
                  img.full-width(:src="getProductImage(product).url" :alt="getProductImage(product).alt_text")
                  .prod-desc
                    p.bold.upper.xs-f-small.max-at-tweak(data-mr-ass="product-name") {{product.name}}
                    p.xs-f-small.max-at-tweak {{product.short_description}}
                    stars.xs-f-medium.max-at-tweak(:product-id="product.id")

        .save-wrap.xs-12.text-center
          button.mr-btn.btn-fixed-width.xs-f-xsmall.max-at-tweak(type="button" @click="changeColor(selectedProduct)" :class="{disabled: !selectedProduct}" data-mr-ass="change-product-save") save

</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';
  import vueSubscriptionSvc from '../../../../services/vueSubscriptionSvc';
  import SectionTitle from "../../../SectionTitle";

  export default {
    name: "EditAutoDeliveryChangeColorModal",
    
    components: {
      SectionTitle
    },

    data() {
      return {
        code: null,
        selectedProduct: null
      }
    },

    mounted() {
      if (this.redirectToAdvisor) {
        window.location = '/color-advisor?next=' + encodeURIComponent(window.location.pathname + '?change=1');
      }
    },

    computed: {
      ...mapState('customer', ['cdata']),
      ...mapState('subscriptions', ['subInEdit']),

      redirectToAdvisor() {
        return !this.cdata.hasBeautyProfile || !this.cdata.bestColorMatch;
      }
    },

    methods: {
      ...mapActions('modal', ['hideModal']),
      ...mapMutations('subscriptions', ['clearSubInEdit']),

      ...mapActions('subscriptions', [
        'loadCustomerSubs',
        'updateSubscriptionColor'
      ]),

      productShouldShow(product) {
        var shouldShow = true;

        if (product.product_type == 'light_works') {
          shouldShow = product.shortHair == this.subInEdit.product_info.extended_info.shortHair && product.lightOrDark == this.subInEdit.product_info.extended_info.lightOrDark;
        }

        return shouldShow;
      },

      getProductImage(product) {
        var img = {
          url: '',
          alt_text: ''
        };

        if (product && product.imagery) {
          if (product.imagery.backie) {
            img.url = product.imagery.backie.url;
            img.alt_text = product.imagery.backie.alt_text;
          } else if (product.imagery.alternative) {
            img.url = product.imagery.alternative.url;
            img.alt_text = product.imagery.alternative.alt_text;
          } else {
            img.url = product.imagery.standard.url;
            img.alt_text = product.imagery.standard.alt_text;
          }
        }

        return img;
      },

      selectProduct(product) {
        this.selectedProduct = product.id != this.subInEdit.product_id ? product : null;
      },

      changeColor(product) {
        this.updateSubscriptionColor({
          subscriptionId: this.subInEdit.id,
          productId: product.id
        }).then(() => {
          this.hideModal();
          this.clearSubInEdit();
          this.$router.push({ name: 'subDashboard'});
        }).catch(() => {
          this.hideModal();
        });
      },

      cancel() {
        this.hideModal();
      }
    }

  }
</script>

<style scoped lang="stylus">
  .edit-auto-delivery-change-color-modal
    .missing-advisor
      padding 3em

    .products-wrap
      padding 1em 0
      
      .choose-wrap
        padding 0 2%
        
      .product-wrap
        padding 0.5em 1.5%
        
        img
          border 3px solid transparent
        
        &.selected
          img
            border-color color-mr-blue
            
        .prod-desc
          min-height 10em
        
      .product-button
        width 100%
        background-color transparent
        border none
        margin 0
        padding 0
    
    @media mq-mobile
      .products-wrap
        .product-wrap
          .prod-desc            
            .mr-stars
              padding-top 0.5em
    
    @media mq-tablet-plus
      .products-wrap
        .product-wrap
          padding 0.5em 2%
          
    @media mq-desktop-md
      .products-wrap
        padding 1em 5%
        
    @media mq-desktop-plus
      .products-wrap
        padding 1em 10%
        
</style>
